import { usePartnerFetchDefectReportApi } from 'api/partner/defect_report';
import { GlobalStateContext } from 'contexts/global_state_context';
import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { PartnerRouteHelper } from 'routes/partner';
import { useEffectSkipFirst } from 'utils/hooks';

type DefectReportShowProps = {};
export const DefectReportShow: React.FC = () => {
  const globalState = useContext(GlobalStateContext);
  const navigate = useNavigate();
  const defectReportApi = usePartnerFetchDefectReportApi();
  const { id } = useParams<{ id: string }>();
  const defectReportId = Number(id);

  useEffect(() => {
    defectReportApi.execute(defectReportId);
  }, []);

  useEffectSkipFirst(() => {
    globalState.setLoading(defectReportApi.loading);
    if (defectReportApi.isSuccess() && defectReportApi.response.defectReport.repairInfoId) {
      navigate(PartnerRouteHelper.repairInfoShow(defectReportApi.response.defectReport.repairInfoId));
    }
  }, [defectReportApi.loading]);

  return <></>;
};

export default DefectReportShow;
